module.exports = __webpack_public_path__ + "static/media/ingredients3.cdaba6af.png";